import { Outlet, createFileRoute } from '@tanstack/react-router';

/**
 * /icons — pathless layout for the @osd/icons icon-kit docs surface.
 *
 * Both sub-pages (Browse at `/icons`, Getting started at
 * `/icons/getting-started`) are top-level entries in the app sidebar
 * already, so no per-page side-nav is rendered here — that would just
 * duplicate the app sidebar.
 *
 * The `@osd/icons` package is a sibling product to `@osd/ui` — same
 * governance, different lifecycle. The two kits share the `--osd-*`
 * design tokens (icons inherit `currentColor` so they pick up
 * `--osd-color-fg` / `--osd-color-fg-muted` from the host context).
 *
 * URL routes:
 *   /icons                       → overview index (the catalog browse)
 *   /icons/getting-started       → install + API + tree-shaking primer
 *   /icons/<page>                → future per-category or per-use-case pages
 *   (re-introduce a per-page side-nav here once a third page lands)
 *
 * Per root/osd#80 (`@osd/icons` umbrella). The sibling-split issue
 * `root/osd#81` (ui-kit + icon-kit split) is closed; the structure
 * it set up is what this layout sits in.
 */

export const Route = createFileRoute('/icons/_layout')({
  component: IconsLayout,
});

function IconsLayout() {
  return <Outlet />;
}
